/**
 * @fileoverview Own linked soft-deadline collection editing within the Redux calendar draft. `SoftDeadlineCard.js` owns individual field presentation; parent event saving owns persistence. Temporary IDs connect local additions/edits without pretending that an unsaved deadline is already a canonical calendar record.
 */

import { useSelector, useDispatch } from 'react-redux';
import { setSoftDeadlinesEnabled, setSoftDeadlines } from '../../store/CalendarInput/action';
import GlassSwitch from './GlassSwitch';
import SoftDeadlineCard from './SoftDeadlineCard';
import Button from "../shared/AppPrimeButton";



const SoftDeadlinesSection = () => {
  const dispatch = useDispatch();
  const softDeadlinesEnabled = useSelector((state) => state.calendarInput.softDeadlinesEnabled);
  const softDeadlines = useSelector((state) => state.calendarInput.softDeadlines);
  const categories = useSelector((state) => state.calendarInput.categories);
  const parentAssignees = useSelector((state) => state.calendarInput.assignedAttorneys);
  const parentDaterange = useSelector((state) => state.calendarInput.daterange);

  const addSoftDeadline =

  () => {
    const now = new Date();
    const oneHourLater = new Date(now.getTime() + 3600000);
    // Use parent daterange if available, otherwise use current time
    const startISO = parentDaterange?.[0] || now.toISOString();
    const endISO = parentDaterange?.[1] || oneHourLater.toISOString();

    const newDeadline = {
      tempId: `sd-${Date.now()}-${Math.random().toString(36).slice(2, 7)}`,
      id: null,
      title: '',
      date: startISO,
      daterange: [startISO, endISO],
      allday: false,
      selectedCategory: categories[0],
      notes: '',
      assignedAttorneys: [...(parentAssignees || [])]
    };
    dispatch(setSoftDeadlines([...softDeadlines, newDeadline]));
  };

  const updateSoftDeadline =

  (tempId, updates) => {
    const updated = softDeadlines.map((sd) =>
    sd.tempId === tempId ? { ...sd, ...updates } : sd
    );
    dispatch(setSoftDeadlines(updated));
  };

  const removeSoftDeadline =

  (tempId) => {
    dispatch(setSoftDeadlines(softDeadlines.filter((sd) => sd.tempId !== tempId)));
  };

  return (
    <div className="col-12 mt-2">
            {/* Toggle row */}
            <div className="flex align-items-center gap-3 mb-2">
                <div className="flex align-items-center gap-2">
                    <label className="font-medium text-900 mb-0">Soft Deadlines</label>
                    <GlassSwitch
            checked={softDeadlinesEnabled}
            onChange={(e) => dispatch(setSoftDeadlinesEnabled(e.value))} />

                </div>
                {softDeadlinesEnabled &&
        <Button
          icon="pi pi-plus"
          label="Add Deadline"
          size="small"
          outlined
          onClick={addSoftDeadline} />}


                {softDeadlinesEnabled && softDeadlines.length > 0 &&
        <span className="text-500 text-sm">
                        {softDeadlines.length} deadline{softDeadlines.length !== 1 ? 's' : ''}
                    </span>}

            </div>

            {/* Soft deadline cards */}
            {softDeadlinesEnabled && softDeadlines.map((sd, index) =>
      <SoftDeadlineCard
        key={sd.tempId}
        deadline={sd}
        index={index}
        onUpdate={updateSoftDeadline}
        onRemove={removeSoftDeadline}
        categories={categories} />

      )}
        </div>);

};

export default SoftDeadlinesSection;
